/**
 * Get the base API endpoint from environment variables
 * Defaults to production endpoint if not set
 */
export function getApiEndpoint(): string {
  return (
    import.meta.env.VITE_API_ENDPOINT || "https://graphql-api.healthmatch.io"
  );
}

/**
 * Get the full API endpoint for a specific path
 * @param path The API path to append to the base endpoint
 */
export function getApiUrl(path: string): string {
  const baseEndpoint = getApiEndpoint();
  return `${baseEndpoint}${path.startsWith("/") ? path : `/${path}`}`;
}
